import { render, staticRenderFns } from "./SubmitWorkers.vue?vue&type=template&id=874e1564&"
import script from "./SubmitWorkers.vue?vue&type=script&lang=js&"
export * from "./SubmitWorkers.vue?vue&type=script&lang=js&"
import style0 from "./SubmitWorkers.vue?vue&type=style&index=0&id=874e1564&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports